import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faBell, faHourglass, faTimes, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import Box4 from '../images/orderDetails_icons/box_hourglass.png';
import {useNotification} from '../../context/NotificationContext';

const Snackbar = forwardRef(({ 
  snackbarState,  
  minimizeSnackbar, 
  expandSnackbar, 
  hideSnackbar, 
 customStyle = {} // Add a default empty object
}, ref) => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  //console.log(orders)
  const { notifications, setNotifications } = useNotification();
  const latestOrder = orders[0];
  //console.log("----notifications:------",notifications);
  //console.log("----latestOrder:------",latestOrder);
  const [expanded, setExpanded] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartY, setDragStartY] = useState(0);
  const [currentHeight, setCurrentHeight] = useState(180);
  const [userData, setUserData] = useState(null);
  const [countdownDetails, setCountdownDetails] = useState({
  isExpired: false,
  timeRemaining: null
});
const [currentOrderIndex, setCurrentOrderIndex] = useState(0);
const [isTransitioning, setIsTransitioning] = useState(false);
const [orderCountdowns, setOrderCountdowns] = useState({});

  // Expose orders to parent component
  useImperativeHandle(ref, () => ({
    orders
  }));

  useEffect(() => {
    const userDetails = JSON.parse(sessionStorage.getItem('vendorData')) || JSON.parse(localStorage.getItem('vendorData'));
  setUserData(userDetails);
  }, []);

  const fetchDigiStoreQuotes = async () => {
  try {
    // Parse vendorData from localStorage
    const vendorDataString = localStorage.getItem('vendorData');
    if (!vendorDataString) {
      console.error('No vendor data found in localStorage');
      return;
    }
    
    const vendorData = JSON.parse(vendorDataString);
    //console.log('Vendor Data:', vendorData);
    
    if (!vendorData || !vendorData.id) {
      console.error('Invalid vendor data or missing vendor ID');
      return;
    }
    
    const token = sessionStorage.getItem('token') || vendorData.token;
    
    // Fetch quotations for this vendor
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-live-order-notifications?userId=${vendorData.id}`, 
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );

    const data = await response.json();
    //console.log('Quotations data:', data);
    
    if (data.success && Array.isArray(data.data)) {
      // Calculate the total number of quotations for ID assignment
     
      // Update the orders state with the formatted data
      setOrders(data.data);
    } else {
      console.error('Failed to fetch quotations or invalid data format');
    }
  } catch (error) {
    console.error('Error fetching quotations:', error);
  }
};

//handleForegroundNotifications(setNotifications);

  useEffect(() => {
    if(userData){
  fetchDigiStoreQuotes();
    }
    
  }, [userData]);


 /*  const getStatusInfo = (status) => {
    
    switch (status) {
      case 'Respond Now':
        return { 
          color: '#10B981', 
          bgColor: '#ECFDF5',
          text: 'Respond Now'
        };
      case 'Accepted':
        return { 
          color: '#10B981', 
          bgColor: '#ECFDF5',
          text: 'Accepted'
        };
      case 'Skipped':
        return { 
          color: '#EF4444', 
          bgColor: '#FEF2F2',
          text: 'Skipped'
        };
         case 'Awarded ':
        return { 
          color: '#EF4444', 
          bgColor: '#FEF2F2',
          text: 'Awarded'
        };
        case 'Not Awarded ':
        return { 
          color: '#EF4444', 
          bgColor: '#FEF2F2',
          text: 'Not Awarded'
        };
      case 'Counter Offer':
        return { 
          color: '#F59E0B', 
          bgColor: '#FFFBEB',
          text: 'Counter Offerd'
        };
      case 'respond now':
      default:
        return { 
          color: '#6B7280', 
          bgColor: '#F9FAFB',
          text: 'Respond now'
        };
    }
  };
 */

  const getStatusInfo = (status) => {
  const normalizedStatus = status?.trim().toLowerCase();

  switch (normalizedStatus) {
    case 'respond now':
      return { 
        color: '#10B981', 
        bgColor: '#ECFDF5',
        text: 'Respond Now'
      };
    case 'accepted':
      return { 
        color: '#10B981', 
        bgColor: '#ECFDF5',
        text: 'Accepted'
      };
    case 'skipped':
      return { 
        color: '#EF4444', 
        bgColor: '#FEF2F2',
        text: 'Skipped'
      };
    case 'awarded':
      return { 
        color: '#EF4444', 
        bgColor: '#FEF2F2',
        text: 'Awarded'
      };
    case 'not awarded':
      return { 
        color: '#EF4444', 
        bgColor: '#FEF2F2',
        text: 'Not Awarded'
      };
    case 'counter offer':
      return { 
        color: '#F59E0B', 
        bgColor: '#FFFBEB',
        text: 'Counter Offer'
      };
    default:
      return { 
        color: '#6B7280', 
        bgColor: '#F9FAFB',
        text: status
      };
  }
};

  const handleDragStart = (e) => {
    setIsDragging(true);
    setDragStartY(e.clientY || e.touches[0].clientY);
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;
    const clientY = e.clientY || (e.touches && e.touches[0].clientY);
    if (!clientY) return;
    
    const deltaY = dragStartY - clientY;
    const newHeight = Math.min(Math.max(80, currentHeight + deltaY), window.innerHeight * 0.7);
    setCurrentHeight(newHeight);
    setDragStartY(clientY);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    if (currentHeight > 150) {
      setExpanded(true);
      setCurrentHeight(window.innerHeight * 0.7);
    } else {
      setExpanded(false);
      setCurrentHeight(80);
    }
  };

  // Toggle expand function
  const toggleExpand = () => {
    if (expanded) {
      // If already expanded, collapse
      setExpanded(false);
      setCurrentHeight(80);
    } else {
      // If not expanded, expand to full height
      setExpanded(true);
      setCurrentHeight(window.innerHeight * 0.7);
    }
  };

  
  // In your existing useEffect for merging notifications into orders

/* useEffect(() => {
  if (notifications.length > 0) {
    setOrders(prevOrders => {
      // If prevOrders is null or empty, initialize with notifications
      if (!prevOrders || prevOrders.length === 0) {
        return notifications.map(notification => ({
          _id: notification.data?.order_id?.replace(/"/g, ''),
          metadata: {
            order_number: notification.data?.order_number,
            items_count: parseInt(notification.data?.items_count || 0),
            total_amount: notification.data?.total_amount,
            order_date: notification.data?.order_date 
              ? new Date(notification.data.order_date.replace(/"/g, '')).toISOString()
              : null,
            order_status: notification.data?.order_status,
            customer_name: notification.data?.customer_name,
            order_id: notification.data?.order_id?.replace(/"/g, '') // Ensure order_id is preserved
          },
          items: Array(parseInt(notification.data?.items_count || 0)).fill({}),
          total: notification.data?.total_amount,
          status: notification.data?.order_status,
          quotation_date: notification.data?.order_date 
            ? new Date(notification.data.order_date.replace(/"/g, '')).toISOString()
            : null,
          hasNewNotification: true,
          fromNotification: true
        })).sort((a, b) => 
          new Date(b.quotation_date || b.createdAt) - new Date(a.quotation_date || a.createdAt)
        );
      }

      let updatedOrders = [...prevOrders];
      let hasUpdates = false;

      notifications.forEach(notification => {
        const notifOrderId = notification.data?.order_id?.replace(/"/g, '');
        const notifStatus = notification.data?.order_status;
        const notifOrderDate = notification.data?.order_date
          ? new Date(notification.data.order_date.replace(/"/g, '')).toISOString()
          : null;

        if (!notifOrderId || !notifStatus) return;

        const existingOrderIndex = updatedOrders.findIndex(
          order => order._id === notifOrderId || order.metadata?.order_id === notifOrderId
        );

        if (existingOrderIndex >= 0) {
          // Update existing order while preserving original order_id
          const existingOrder = updatedOrders[existingOrderIndex];
          updatedOrders[existingOrderIndex] = {
            ...existingOrder,
            status: notifStatus,
            hasNewNotification: true,
            quotation_date: notifOrderDate || existingOrder.quotation_date,
            metadata: {
              ...existingOrder.metadata,
              order_status: notifStatus,
              order_date: notifOrderDate || existingOrder.metadata?.order_date,
              // Preserve the original order_id if it exists, otherwise use the notification order_id
              order_id: existingOrder.metadata?.order_id || notifOrderId
            }
          };
          hasUpdates = true;
        } else {
          // Add new order from notification
          updatedOrders.unshift({
            _id: notifOrderId,
            metadata: {
              order_number: notification.data?.order_number,
              items_count: parseInt(notification.data?.items_count || 0),
              total_amount: notification.data?.total_amount,
              order_date: notifOrderDate,
              order_status: notifStatus,
              customer_name: notification.data?.customer_name,
              order_id: notifOrderId // Ensure this matches the _id
            },
            items: Array(parseInt(notification.data?.items_count || 0)).fill({}),
            total: notification.data?.total_amount,
            status: notifStatus,
            quotation_date: notifOrderDate,
            hasNewNotification: true,
            fromNotification: true
          });
          hasUpdates = true;
        }
      });

      if (hasUpdates) {
        return updatedOrders.sort((a, b) => {
          if (a.hasNewNotification && !b.hasNewNotification) return -1;
          if (!a.hasNewNotification && b.hasNewNotification) return 1;
          return new Date(b.quotation_date || b.createdAt) - new Date(a.quotation_date || a.createdAt);
        });
      }

      return prevOrders;
    });
  }
}, [notifications]); */

useEffect(() => {
  if (notifications.length > 0) {
    setOrders(prevOrders => {
      // 1. Get all order IDs from notifications (for removal)
      const notificationOrderIds = notifications
        .map(n => n.data?.order_id?.replace(/"/g, ''))
        .filter(Boolean); // Remove any undefined/null

      // 2. Filter notifications - only keep:
      //    - "respond now" status
      //    - "awarded" with "in progress" fulfillment
      const validNotifications = notifications.filter(notification => {
        const status = notification.data?.order_status?.toLowerCase();
        const fulfillmentStatus = notification.data?.in_fulfillment_status?.toLowerCase();

        return (
          status === 'respond now' ||
          (status === 'awarded' && fulfillmentStatus === 'in progress')
        );
      });

      // 3. If no previous orders, initialize with only valid notifications
      if (!prevOrders || prevOrders.length === 0) {
        return validNotifications.map(notification => ({
          _id: notification.data?.order_id?.replace(/"/g, ''),
          metadata: {
            order_number: notification.data?.order_number,
            items_count: parseInt(notification.data?.items_count || 0),
            total_amount: notification.data?.total_amount,
            order_date: notification.data?.order_created_at 
              ? new Date(notification.data.order_created_at.replace(/"/g, '')).toISOString()
              : null,
            order_waiting_time : notification.data?.order_waiting_time,
            order_status: notification.data?.order_status,
            customer_name: notification.data?.customer_name,
            order_id: notification.data?.order_id?.replace(/"/g, ''),
            in_fulfillment_status: notification.data?.in_fulfillment_status
          },
          items: Array(parseInt(notification.data?.items_count || 0)).fill({}),
          total: notification.data?.total_amount,
          status: notification.data?.order_status,
          quotation_date: notification.data?.order_date 
            ? new Date(notification.data.order_date.replace(/"/g, '')).toISOString()
            : null,
          hasNewNotification: true,
          fromNotification: true
        })).sort((a, b) => 
          new Date(b.quotation_date || b.createdAt) - new Date(a.quotation_date || a.createdAt)
        );
      }

      // 4. Remove any existing orders that match notification IDs
      let updatedOrders = prevOrders.filter(order => 
        !notificationOrderIds.includes(order._id) && 
        !notificationOrderIds.includes(order.metadata?.order_id)
      );

      let hasUpdates = updatedOrders.length !== prevOrders.length;

      // 5. Add back only the valid notifications
      validNotifications.forEach(notification => {
        const notifOrderId = notification.data?.order_id?.replace(/"/g, '');
        const notifStatus = notification.data?.order_status;
        const notifOrderDate = notification.data?.order_created_at 
              ? new Date(notification.data.order_created_at.replace(/"/g, '')).toISOString()
              : null;

        if (!notifOrderId || !notifStatus) return;

        // Add as new order (since we removed all matching IDs earlier)
        updatedOrders.unshift({
          _id: notifOrderId,
          metadata: {
            order_number: notification.data?.order_number,
            items_count: parseInt(notification.data?.items_count || 0),
            total_amount: notification.data?.total_amount,
              order_date: notifOrderDate,
            order_waiting_time : notification.data?.order_waiting_time,
            order_status: notifStatus,
            customer_name: notification.data?.customer_name,
            order_id: notifOrderId,
            in_fulfillment_status: notification.data?.in_fulfillment_status
          },
          items: Array(parseInt(notification.data?.items_count || 0)).fill({}),
          total: notification.data?.total_amount,
          status: notifStatus,
          quotation_date: notifOrderDate,
          hasNewNotification: true,
          fromNotification: true
        });
        hasUpdates = true;
      });

      // 6. Return updated orders if changes occurred
      return hasUpdates 
        ? updatedOrders.sort((a, b) => {
            // New notifications first
            if (a.hasNewNotification && !b.hasNewNotification) return -1;
            if (!a.hasNewNotification && b.hasNewNotification) return 1;
            // Then by date (newest first)
            return new Date(b.quotation_date || b.createdAt) - new Date(a.quotation_date || a.createdAt);
          })
        : prevOrders;
    });
  }
}, [notifications]);


// Navigates user to the Order details which has been received through notifications - Only order with Respond Now and withint expired time.
/* useEffect(() => {
  if (notifications.length > 0) {
    // Sort notifications by timestamp in descending order (most recent first)
    const sortedNotifications = [...notifications].sort((a, b) =>
      new Date(b.timestamp) - new Date(a.timestamp)
    );

    // Find the first notification with "Respond Now" status
    const respondNowNotification = sortedNotifications.find(notification => {
      // Ensure notification and data exist
      if (!notification || !notification.data) return false;

      // Multiple ways to check "Respond Now" status
      const isRespondNowStatus =
        notification.data.order_status?.toLowerCase() === 'respond now' ||
        notification.data.vendor_response_status?.toLowerCase() === 'respond now';
      
      return isRespondNowStatus;
    });

    // If a "Respond Now" notification is found, navigate
    if (respondNowNotification) {
      const orderIdToNavigate =
        respondNowNotification.data?.order_id?.replace(/"/g, '') ||
        respondNowNotification.data?._id;

      // Additional safety checks
      if (orderIdToNavigate) {
        // Clear notifications before navigation
        // Assuming you have a function to set notifications to an empty array
        // This could be passed as a prop or managed in a parent component
        if (typeof setNotifications === 'function') {
          setNotifications([]);
        }

        navigate('/supplier/orderdetails', {
          state: {
            quotationId: orderIdToNavigate,
            vendor_id: userData?.id,
            order_number: respondNowNotification.data?.order_number
          }
        });
      }
    }
  }
}, [notifications, navigate, userData, setNotifications]);
 */

// Navigates user to the Order details for actionable notifications
useEffect(() => {
  if (notifications.length > 0) {
    // Sort notifications by timestamp in descending order (most recent first)
    const sortedNotifications = [...notifications].sort((a, b) =>
      new Date(b.timestamp) - new Date(a.timestamp)
    );

    // Find the first actionable notification
    const actionableNotification = sortedNotifications.find(notification => {
      if (!notification?.data) return false;

      const status = notification.data.order_status?.toLowerCase();
      const fulfillmentStatus = notification.data.in_fulfillment_status?.toLowerCase();
      
      // Check for actionable statuses
      const isRespondNow = status === 'respond now';
      const isAwardedInProgress = status === 'awarded' && fulfillmentStatus === 'in progress';
      
      // For "Respond Now", also check if not expired
      if (isRespondNow) {
        const orderDate = notification.data?.order_created_at || notification.data?.order_date;
        const expiryTimeInMinutes = notification.data?.order_waiting_time;
        
        if (orderDate && expiryTimeInMinutes) {
          const countdown = calculateCountdown(orderDate, expiryTimeInMinutes);
          return !countdown.isExpired;
        }
        return true; // If no expiry data, consider it actionable
      }
      
      return isAwardedInProgress;
    });

    // Navigate if actionable notification found
    if (actionableNotification) {
      const orderIdToNavigate = actionableNotification.data?.order_id?.replace(/"/g, '') || actionableNotification.data?._id;

      if (orderIdToNavigate) {
        // Clear notifications before navigation
        if (typeof setNotifications === 'function') {
          setNotifications([]);
        }

        navigate('/supplier/rfqdetails', {
          state: {
            quotationId: orderIdToNavigate,
            vendor_id: userData?.id,
            order_number: actionableNotification.data?.order_number,
            order_status: actionableNotification.data?.order_status,
            from: 'home'
          }
        });
      }
    }
  }
}, [notifications, navigate, userData, setNotifications]);


/*   // Modify the orders state management to prioritize new and recent orders
  useEffect(() => {
    if (notifications.length > 0 || orders.length > 0) {
      setOrders(prevOrders => {
        // Combine existing orders with new notifications
        let combinedOrders = [...prevOrders];

        notifications.forEach(notification => {
          const notifOrderId = notification.data?.order_id?.replace(/"/g, '');
          
          // Check if order already exists
          const existingOrderIndex = combinedOrders.findIndex(
            order => order._id === notifOrderId || order.metadata?.order_id === notifOrderId
          );

          if (existingOrderIndex === -1) {
            // Add new notification order
            combinedOrders.unshift({
              _id: notifOrderId,
              metadata: {
                order_number: notification.data?.order_number,
                items_count: parseInt(notification.data?.items_count || 0),
                total_amount: notification.data?.total_amount,
                order_date: notification.data?.order_date 
                  ? new Date(notification.data.order_date.replace(/"/g, '')).toISOString()
                  : null,
                order_status: notification.data?.order_status,
                customer_name: notification.data?.customer_name,
                order_id: notifOrderId
              },
              status: notification.data?.order_status,
              hasNewNotification: true,
              fromNotification: true
            });
          }
        });

        // Sort orders by recency and new notifications
        return combinedOrders.sort((a, b) => {
          // Prioritize new notifications
          if (a.hasNewNotification && !b.hasNewNotification) return -1;
          if (!a.hasNewNotification && b.hasNewNotification) return 1;
          
          // Then sort by date
          const dateA = new Date(a.metadata?.order_date || a.quotation_date);
          const dateB = new Date(b.metadata?.order_date || b.quotation_date);
          return dateB - dateA;
        });
      });
    }
  }, [notifications]);
 */
  // Rotate orders through orders every 10 seconds
useEffect(() => {
  // Filter orders with 'respond now' or 'awarded'
  const rotatableOrders = orders.filter(order =>
    ['respond now', 'awarded'].includes(
      order?.metadata?.order_status?.toLowerCase()
    )
  );

  // If no valid orders, stop rotation
  if (rotatableOrders.length === 0) {
    setIsTransitioning(false);
    return;
  }

  // If only one valid order — stop rotation, but make sure it's displayed
  if (rotatableOrders.length === 1) {
    const validOrderId = rotatableOrders[0]?._id;
    const indexInAllOrders = orders.findIndex(o => o._id === validOrderId);
    if (indexInAllOrders !== -1) {
      setCurrentOrderIndex(indexInAllOrders);
    }
    setIsTransitioning(false);
    return;
  }

  // If currentOrderIndex points to an invalid order, shift to the first valid one
  const currentOrder = orders[currentOrderIndex];
  const currentStatus = currentOrder?.metadata?.order_status?.toLowerCase();
  const isCurrentValid = ['respond now', 'awarded'].includes(currentStatus);

  if (!isCurrentValid) {
    const firstValid = rotatableOrders[0]?._id;
    const validIndex = orders.findIndex(o => o._id === firstValid);
    if (validIndex !== -1) {
      setCurrentOrderIndex(validIndex);
    }
  }

  const rotateOrders = () => {
    setIsTransitioning(true);

    setCurrentOrderIndex(prevIndex => {
      let nextIndex = (prevIndex + 1) % orders.length;
      let attempts = 0;

      // Skip invalid orders
      while (
        attempts < orders.length &&
        !['respond now', 'awarded'].includes(
          orders[nextIndex]?.metadata?.order_status?.toLowerCase()
        )
      ) {
        nextIndex = (nextIndex + 1) % orders.length;
        attempts++;
      }

      return nextIndex;
    });

    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 500);

    return () => clearTimeout(timer);
  };

  const intervalId = setInterval(rotateOrders, 10000);
  return () => clearInterval(intervalId);
}, [orders]);



// Add a new useEffect to manage individual order countdowns
useEffect(() => {
  // Create a countdown tracker for each order
  const countdownTracker = {};
  
  orders.forEach(order => {
     const orderDate = order.metadata?.order_created_at || order.metadata?.order_date;
     const expiryTimeinMinutes =  order.metadata?.order_waiting_time ;
    if (orderDate) {
      const countdown = calculateCountdown(orderDate, expiryTimeinMinutes);
      countdownTracker[order._id] = countdown;
    }
  });

  setOrderCountdowns(countdownTracker);

  // Set up intervals for each order's countdown
  const intervalIds = {};
  
  orders.forEach(order => {
    const orderDate = order.metadata?.order_created_at || order.metadata?.order_date;
    const expiryTimeinMinutes =  order.metadata?.order_waiting_time ;
    if (orderDate) {
      intervalIds[order._id] = setInterval(() => {
        const updatedCountdown = calculateCountdown(orderDate, expiryTimeinMinutes);
        
        setOrderCountdowns(prev => ({
          ...prev,
          [order._id]: updatedCountdown
        }));

        // Clear interval if expired
        if (updatedCountdown.isExpired) {
          clearInterval(intervalIds[order._id]);
        }
      }, 1000);
    }
  });

  // Cleanup function
  return () => {
    Object.values(intervalIds).forEach(clearInterval);
  };
}, [orders]);


  // Countdown calculation function
// Modify the calculateCountdown function to be more flexible
const calculateCountdown = (date , expirytime) => {
  if (!date) return null;

 const startTime = new Date(date);
  // Convert expirytime to milliseconds
  const expirationTime = new Date(startTime.getTime() + parseInt(expirytime) * 60 * 1000);
  const now = new Date();

  // Check if the order is already older than 30 minutes
  if (now >= expirationTime) {
    return {
      isExpired: true,
      timeRemaining: null
    };
  }

  const difference = expirationTime - now;
  const minutes = Math.floor((difference / 1000 / 60) % 60);
  const seconds = Math.floor((difference / 1000) % 60);

  return {
    isExpired: false,
    timeRemaining: { minutes, seconds }
  };
};

  // Effect to update countdown every second
  useEffect(() => {
    if (orders.length > 0) {
      const latestOrderData = orders[0];
      
      if (latestOrderData?.metadata?.order_date) {
        const timer = setInterval(() => {
          const orderDate = latestOrderData.metadata?.order_created_at || latestOrderData.metadata?.order_date;
    const expiryTimeinMinutes =  latestOrderData.metadata?.order_waiting_time ;
          const countdownResult = calculateCountdown(orderDate, expiryTimeinMinutes);
          
          if (countdownResult) {
            setCountdownDetails(countdownResult);

            // Clear interval if expired
            if (countdownResult.isExpired) {
              clearInterval(timer);
            }
          }
        }, 1000);

        // Cleanup interval on component unmount or when orders change
        return () => clearInterval(timer);
      }
    }
  }, [orders]); 

  
useEffect(() => {
  // Ensure orders exist and is an array
  if (!orders || !Array.isArray(orders)) return;

  // More verbose logging for debugging
  /* console.log('Current orders before filtering:', orders.map(order => ({
    id: order._id,
    status: order.status,
    orderDate: order.metadata?.order_date || order.quotation_date,
    countdown: calculateCountdown(order.metadata?.order_date || order.quotation_date)
  }))); */

  // Explicitly filter out expired "Respond Now" orders
  const cleanedOrders = orders.filter(order => {
    // Explicitly check for "Respond Now" status
    const isRespondNowStatus = 
      order.status?.toLowerCase() === 'respond now' || 
      order.metadata?.order_status?.toLowerCase() === 'respond now';

    // Calculate countdown with multiple fallback date sources
     const orderDate = order.metadata?.order_created_at || order.metadata?.order_date;
    const expiryTimeinMinutes =  order.metadata?.order_waiting_time ;

    const orderCountdown = calculateCountdown(orderDate , expiryTimeinMinutes);

    // Detailed logging for each order's filtering decision
    if (isRespondNowStatus && orderCountdown.isExpired) {
    /*   console.log(`Removing expired order:`, {
        orderId: order._id,
        status: order.status,
        isExpired: orderCountdown.isExpired
      }); */
    }

    // Keep order if:
    // 1. Not a "Respond Now" status, OR
    // 2. Countdown is not expired
    return !(isRespondNowStatus && orderCountdown.isExpired);
  });

  // Only update if there's a change in orders
  if (cleanedOrders.length !== orders.length) {
    //console.log(`Removing ${orders.length - cleanedOrders.length} expired "Respond Now" orders`);
    setOrders(cleanedOrders);
  }
}, [orders]); // Dependency is orders

  // Render method for countdown
// In the collapsed state rendering
const renderCountdown = () => {
  const orderCountdown = orderCountdowns[currentOrder._id];

  if (!orderCountdown) return null;

  if (orderCountdown.isExpired) {
    return (
      <div className="flex items-center space-x-2">
        <span className="text-xs text-red-500">Expired</span>
        <FontAwesomeIcon
          icon={faHourglass}
          className="text-red-500 animate-pulse"
        />
      </div>
    );
  }

  if (orderCountdown.timeRemaining) {
    const { minutes, seconds } = orderCountdown.timeRemaining;
    return (
      <div className="flex items-center space-x-2">
        <div className="w-14 h-14 rounded-full border-2 border-[#ECE5E5] text-lg text-[#F84C5C] font-semibold flex justify-evenly items-center">
          <span>{minutes}</span>
          <p>:</p>
          <span>{seconds < 10 ? `0${seconds}` : seconds}</span>
        </div>
      </div>
    );
  }

  // Fallback
  return (
    <div className="flex items-center space-x-2">
      <span className="text-xs text-gray-500">--</span>
      <FontAwesomeIcon
        icon={faHourglass}
        className="text-gray-300"
      />
    </div>
  );
};


  if (!snackbarState.show || orders.length === 0) {
    return null;
  }
   const statusInfo = getStatusInfo(latestOrder?.metadata?.order_status);

   // Get current displayed order
  const currentOrder = orders[currentOrderIndex] || orders[0];

  // Render method for collapsed state
  const renderCollapsedState = () => {
    if (!currentOrder) return null;

    const statusInfo = getStatusInfo(currentOrder?.metadata?.order_status);

    return (
      <div className="relative flex items-center px-3">
        {/* Orders count badge */}
        <div className="absolute inset-x-0 -top-2 flex justify-center z-10">
          <div 
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand();
            }}
            className="flex flex-row justify-evenly items-center bg-[#F43042] px-3 py-0.5 text-[11px] font-semibold text-white rounded-lg shadow border border-gray-200 tracking-wide cursor-pointer hover:bg-[#d63384] transition-colors"
          >
            <span className='mr-1 text-[#F43042] px-1 bg-white rounded-full text-xs font-semibold'>
              {orders?.length}
            </span>
            New Orders
            <FontAwesomeIcon icon={faChevronUp} className="ml-1" size="xs" />
          </div>
        </div>
        
        {/* Main content for collapsed state - Rotating Orders */}
        <div 
          className={`space-x-2 flex items-center w-full mt-2 cursor-pointer hover:bg-gray-50 rounded-lg p-2 transition-all duration-500 ${
            isTransitioning ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
          }`}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/supplier/rfqdetails`, { 
              state: { 
                quotationId: currentOrder.metadata?.order_id || currentOrder._id, 
                vendor_id: userData?.id ,
                from: 'home'
              }
            });
          }}
        > 
          {/* Order content */}
          <div className="relative mr-2">
            {!currentOrder.fromNotification ? (
              <img 
                src={Box4} 
                alt="Order items"
                className="bg-[#FAF4F4] w-14 h-14 rounded-xl object-cover"
              />
            ) : (
              <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center">
                <FontAwesomeIcon icon={faBell} className="text-blue-500 text-base" />
              </div>
            )}
            {currentOrder.hasNewNotification && (
              <div className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse"></div>
            )}
          </div>

          <div className="flex-1 min-w-0">
            <div className='flex flex-row justify-start items-center gap-2'>
              <h4 className="text-sm font-medium text-black truncate leading-tight">
                #{currentOrder.metadata?.order_number || currentOrder.quotation_number || 'N/A'}
              </h4>
              {currentOrder.hasNewNotification && (
                <span className='font-semibold rounded-lg text-[10px] text-[#F84C5C] border border-[#F84C5C] px-1 py-0.5'>
                  NEW
                </span>
              )}
            </div>
            <p className="text-sm font-medium text-[#524D4D] truncate leading-tight">
              ₹{currentOrder.metadata?.total_amount?.toLocaleString('en-IN') || currentOrder.total?.toLocaleString('en-IN') || '0'}
            </p>
            <p className="text-sm font-semibold text-[#524D4D] truncate leading-tight">
              {statusInfo.text}
            </p>
          </div>

          <div className="flex-shrink-0">
            {(currentOrder.status?.toLowerCase() === 'respond now' || 
              currentOrder.metadata?.order_status?.toLowerCase() === 'respond now') && 
              !countdownDetails.isExpired && (
              renderCountdown()
            )}
          </div>
        </div>
      </div>
    );
  };

// Modify the countdown rendering to use individual order countdowns
const renderCountdownForOrder = (order) => {
  const orderCountdown = orderCountdowns[order._id];

  if (!orderCountdown) return null;

  if (orderCountdown.isExpired) {
    return (
      <div className="flex items-center space-x-1">
        <span className="text-xs text-red-500">Expired</span>
        <FontAwesomeIcon
          icon={faHourglass}
          className="text-red-500 text-xs animate-pulse"
        />
      </div>
    );
  }

  if (orderCountdown.timeRemaining) {
    const { minutes, seconds } = orderCountdown.timeRemaining;
    return (
      <div className="flex items-center space-x-2">
        <div className="w-14 h-14 rounded-full border-2 border-[#ECE5E5] text-lg text-[#F84C5C] font-semibold flex justify-evenly items-center">
          <span>{minutes}</span>
          <p>:</p>
          <span>{seconds < 10 ? `0${seconds}` : seconds}</span>
        </div>
      </div>
    );
  }

  // Fallback
  return (
    <div className="flex items-center space-x-1">
      <span className="text-xs text-gray-500">--</span>
      <FontAwesomeIcon
        icon={faHourglass}
        className="text-gray-300 text-xs"
      />
    </div>
  );
};

return (
  <>
    {/* Backdrop overlay for expanded state */}
    {expanded && (
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-10"
        onClick={() => {
          setExpanded(false);
          setCurrentHeight(80);
        }}
      />
    )}

    {/* Main snackbar container */}
   <div 
        className={`fixed left-1/2 transform -translate-x-1/2 z-10 shadow-lg transition-all duration-300 ${
          expanded 
            ? 'bg-white rounded-t-xl border-t border-gray-200 w-[95%] max-w-[600px]' 
            : 'border border-[#E0D9D9] bg-white rounded-lg w-[95%] mx-auto'
        }`}
      style={{
          bottom: expanded ? 0 : '20px',
          height: expanded ? `${currentHeight}px` : 'auto',
          touchAction: 'none',
          ...customStyle // Spread the custom style, which will override default bottom
        }}
      
      onTouchStart={expanded ? handleDragStart : undefined}
      onTouchMove={expanded ? handleDragMove : undefined}
      onTouchEnd={expanded ? handleDragEnd : undefined}
      onMouseDown={expanded ? handleDragStart : undefined}
      onMouseMove={expanded ? handleDragMove : undefined}
      onMouseUp={expanded ? handleDragEnd : undefined}
      onMouseLeave={expanded ? handleDragEnd : undefined}
    >
      {!expanded ? (
        /* COLLAPSED STATE - Rotating Orders */
        renderCollapsedState()
      ) : (
        /* EXPANDED STATE - All orders navigation */
        <>
    {/* Drag handle */}
    <div className="flex justify-center pt-2 cursor-grab active:cursor-grabbing">
      <div className="w-10 h-1 bg-gray-300 rounded-full"></div>
    </div>

    {/* Scrollable list of ALL orders */}
    <div 
      className="overflow-y-auto"
      style={{ height: `calc(${currentHeight}px - 60px)` }}
    >
      <div className="divide-y divide-gray-100">
        {orders.map((order) => {
          const metadata = order.metadata || order;
          const orderStatus = getStatusInfo(metadata.order_status || order.status);
          
          // Use the new orderCountdowns state for individual order countdown
          const orderCountdown = orderCountdowns[order._id];
          const isRespondNowStatus = 
            order.status?.toLowerCase() === 'respond now' || 
            order.metadata?.order_status?.toLowerCase() === 'respond now';

          return (
            <div
              key={order._id}
              className="flex items-center p-3 hover:bg-gray-50 cursor-pointer transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/supplier/rfqdetails`, {
                  state: {
                    quotationId: order.metadata?.order_id || order._id,
                    vendor_id: userData?.id,
                    from: 'home'
                  }
                });
                setExpanded(false);
                setCurrentHeight(80);
              }}
            > 
              {/* Order image */}
              <div className="relative mr-3">
                {order.fromNotification ? (
                  <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                    <FontAwesomeIcon icon={faBell} className="text-blue-500 text-sm" />
                  </div>
                ) : (
                  <img 
                    src={Box4} 
                    alt="Order items" 
                    className="w-10 h-10 rounded-full border-2 border-white object-cover"
                  />
                )}
                {order.hasNewNotification && (
                  <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                )}
              </div>

              {/* Order details */}
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-black truncate tracking-tight">
                  #{metadata.order_number || order.quotation_number || 'N/A'}
                </h4>
                <p className="text-sm font-medium text-[#524D4D] truncate leading-tight">
                  ₹{metadata.total_amount?.toLocaleString('en-IN') || order.total?.toLocaleString('en-IN') || '0'}
                </p>
                <p className="text-sm font-semibold text-[#524D4D] truncate leading-tight">
                  {orderStatus.text}
                </p>
              </div>

              {/* Countdown */}
              <div className="flex flex-col items-end ml-2">
                {isRespondNowStatus && orderCountdown && !orderCountdown.isExpired && (
                  <div className="mt-1">
                    {renderCountdownForOrder(order)}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
    </>
      )}
    </div>
  </>
);




});

export default Snackbar;